// extracted by mini-css-extract-plugin
module.exports = {"row":"body-text-two-columns_row__PXCk_","column":"body-text-two-columns_column__m9tno"};